import { getClickedStatusToggle } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import ChatFilterOptions from 'conversations-internal-schema/constants/ChatFilterOptions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { useStatusToggle } from '../hooks/useStatusToggle';
import { MultiButtonToggle } from 'svh-workspace-ui-lib/search-and-filter/MultiButtonToggle';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusToggle = () => {
  const {
    statusToggle,
    setStatusToggle
  } = useStatusToggle();
  return /*#__PURE__*/_jsx(MultiButtonToggle, {
    onChangeHandler: evt => {
      setStatusToggle(evt.target.value);
      trackEvent(getClickedStatusToggle({
        status: evt.target.value
      }));
    },
    buttonOptions: [{
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-ui.thread-search-and-filtering.status.open'
      }),
      value: ChatFilterOptions.STARTED
    }, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'conversations-inbox-ui.thread-search-and-filtering.status.closed'
      }),
      value: ChatFilterOptions.ENDED
    }],
    value: statusToggle
  });
};
StatusToggle.displayName = 'StatusToggle';